
import React from "react";
import { Label } from "@/components/ui/label";
import { FormFieldType } from "@/types/form";
import { useTranslation } from "react-i18next";
import { tField } from "../utils/i18nField";

interface FieldLabelProps {
  element: FormFieldType;
}

export const FieldLabel: React.FC<FieldLabelProps> = ({ element }) => {
  const { t } = useTranslation();
  if (!element.label) return null;

  return (
    <div className="mb-2">
      <Label htmlFor={element.id} className="block text-sm font-medium">
        {tField(t, element.label)}
        {element.required && <span className="text-red-500 ml-1">*</span>}
      </Label>
      {element.description && (
        <p className="text-sm text-gray-500 mt-1 whitespace-pre-line">{tField(t, element.description)}</p>
      )}
    </div>
  );
};

export default FieldLabel;
